import styled, { css } from 'styled-components'
import { Color } from '../color'
import { shadowCtaCss } from './shared'

const baseButtonCss = css`
  background: none;
  border: 0;
  font-family: 'Circular Std';
  color: inherit;
  line-height: normal;
  overflow: visible;
  padding: 0px;
  user-select: none; /* for button */
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  cursor: pointer;

  &:disabled {
    cursor: inherit;
  }
  &::-moz-focus-inner {
    border: 0;
    padding: 0;
  }
`

export const CustomButton = styled.button`
  ${baseButtonCss}
`

export const blueButtonCss = css`
  ${baseButtonCss}
  height: 60px;
  border-radius: 30px;
  padding: 0 40px;
  color: ${Color.white};
  font-size: 16px;
  letter-spacing: 0.03em;

  cursor: pointer;
  text-transform: uppercase;
  background-color: ${Color.purple_600};

  &:hover {
    background-color: ${Color.purple_600};
  }
  &:disabled {
    background-color: #d8e2ea;
  }
`

export const BlueButton = styled(CustomButton)`
  ${blueButtonCss}
`

export const YellowButton = styled(CustomButton)`
  ${baseButtonCss}
  height: 40px;
  border-radius: 20px;
  background-color: #f5a800;
  padding: 0 40px;
  font-size: 14px;
  font-weight: bold;
  color: ${Color.white};
  white-space: nowrap;

  cursor: pointer;
  text-transform: uppercase;

  &:hover {
    background-color: #f49000;
  }
`

export const ShadowButton = styled(BlueButton)`
  ${shadowCtaCss}
`
